import * as tslib_1 from "tslib";
import { settings } from '../../settings/settings';
import { CouponActionTypes } from '../types/ActionTypes';
import CouponsSession from '../utils/CouponSession/CouponsSession';
import Coupons from '../utils/Coupons';
import { CouponPage } from '../../globalTypes';
import { ProductType } from '../../globalTypes/ProductContext';
export function getCouponReference(urlSearchParams) {
    var _this = this;
    var coreUrl = settings.coreApi.prefix +
        (urlSearchParams.get('productType') === ProductType.HOTEL ?
            (settings.coreApi.endPoints.hotel.base + settings.coreApi.endPoints.hotel.offer) :
            (settings.coreApi.endPoints.package.base + settings.coreApi.endPoints.package.offer));
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var params, requestUrl, couponReference, res, offerResponse, validCoupons, market, couponsSession, couponSessionObject, receiveCouponAction, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = urlSearchParams.toString();
                    requestUrl = params.length > 0 ? coreUrl + '?' + params : coreUrl;
                    couponReference = {};
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(requestUrl)];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    offerResponse = _a.sent();
                    if (!(typeof offerResponse.references !== 'undefined' && typeof offerResponse.references.coupon !== 'undefined' && Object.keys(offerResponse.references.coupon).length > 0)) return [3 /*break*/, 5];
                    validCoupons = Object.values(offerResponse.references.coupon).filter(function (cr) { return Coupons.isCouponMatchesCriteria(cr, CouponPage.BOOKING); });
                    couponReference = Coupons.getBestMatchingCoupon(validCoupons);
                    market = parseInt(urlSearchParams.get('market'), 10);
                    couponsSession = CouponsSession.getInstance();
                    return [4 /*yield*/, couponsSession.getCouponObjectFromUserSession(couponReference, market)];
                case 4:
                    couponSessionObject = _a.sent();
                    receiveCouponAction = {
                        couponReference: couponReference,
                        type: CouponActionTypes.RECEIVE_COUPON,
                        couponCode: couponSessionObject.code,
                        validUntil: couponSessionObject.validUntil
                    };
                    return [2 /*return*/, dispatch(receiveCouponAction)];
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, dispatch({
                        'type': CouponActionTypes.RECEIVE_COUPON_FAILED
                    })];
            }
        });
    }); };
}
